import styled from 'styled-components'

export const Wrap = styled('form')`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 20px;
  border-bottom: 1px solid #c4cacc;
  padding-bottom: 15px;
`

export const Title = styled('div')`
  font-family: var(--bold);
  font-size: 14px;
  color: var(--text);
  white-space: nowrap;
`
